import {Component, Input, Optional, Self} from '@angular/core';
import {ControlValueAccessor, NgControl} from '@angular/forms';

@Component({
    selector: 'employee-request-input',
    templateUrl: './request-input.component.html',
    styleUrls: ['./request-input.component.less'],
})
export class RequestInputComponent implements ControlValueAccessor {

    @Input() title: string;
    @Input() placeholder: string = 'Enter';
    @Input() isRequired = true;
    @Input() type: 'text' | 'date' | 'datetime-local' | 'email' = 'text';
    @Input() notFeature = false;
    @Input() mask: string = '';
    @Input() minValue: string | 'today';
    @Input() maxDate: Date;
    @Input() prefix: string = '';
    @Input() maxLength = 200;
    @Input() infoText = '';
    @Input() disabled = false;
    @Input() noOfDays: number;
    @Input() maskPhoneErrText: string = 'Invalid phone format';
    @Input() maskEmailErrText: string = 'Invalid email format';
    @Input() requiredErrText: string = 'Required';
  
    value: string = '';
    touched = false;

    internalPrefix = '';
    internalMask = '';
    errors = [];
    
    constructor(@Optional() @Self() public control: NgControl) {
        if (control) {
            control.valueAccessor = this;
        }
    }
   
    get _minValue(): string {
        if (!this.minValue) {
            return null;
        }

        if (this.type === 'text') {
            return this.minValue;
        } else {
            let minDate = new Date(this.minValue);
            if (this.minValue === 'today') {
                minDate = new Date();
            }
            const result = (this.type === 'date')
                ? minDate.toISOString().split('T')[0]
                : minDate.toISOString().slice(0, -8);
            return result;
        }
    }

    get maxValue(): any {
        if (this.minValue && this.noOfDays) {
            let minDate = new Date(this.minValue);
            if (this.minValue === 'today') {
                minDate = new Date();
            }
            let maxDate = new Date(minDate);
            maxDate.setDate(minDate.getDate() + this.noOfDays);
            return this.type === 'date'
                ? maxDate.toISOString().split('T')[0]
                : maxDate.toISOString().slice(0, -8);
            //return result;
        }
        return (this.type === 'datetime-local' && this.minValue)
             ? '2055-02-15T00:00'
             : null;
    }
    // get maxValue(): any {
    //     if (this.maxDate) {
    //         let minDate = new Date(this.minValue);
    //         let maxDate = new Date(minDate);
    //         maxDate.setDate(minDate.getDate() + this.noOfDays);
    //         //console.log(this.maxDate);
    //         return this.maxDate.toISOString().split('T')[0];
    //     }
    //     return (this.type === 'datetime-local' && this.minValue)
    //         ? '2055-02-15T00:00'
    //         : null;
    // }

    get isEmail(): boolean {
        return this.type === 'email';
    }
  
    writeValue(value: string): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
    }

    maskUpdate(value: string): void {
        this.internalPrefix = value ? this.prefix : '';
        this.internalMask = value ? this.mask : '';
    }

    inputHandler($event: Event): void {
        const inputValue = ($event.target as HTMLInputElement).value;
        if (this.prefix || this.mask) {
            this.maskUpdate(inputValue);
        }
        this.touched = true;

        this.onChange(this.prefix ? inputValue : this.value);
        this.onTouch();
    }

    private onChange: any = () => {
    }

    private onTouch: any = () => {
    }
}
